<template lang="pug">
  div()
    v-card.Feedback(justify-center, float)
      v-card-text.title(v-if="currentStep.question.answer == currentStep.question.options.find(op=> op.correct).label")
        | Muy bien hecho!!!!
        v-card-text
        | {{currentStep.question.feedback.find(op=> op.correct).label}}
      v-card-text.title(v-else-if="state == false")
        | No es correcto.
        v-card-text
        | {{currentStep.question.feedback.find(op=> !op.correct).label}}
</template>

<script>

import { mapGetters } from 'vuex';
import buttonSend from "@/components/button-send/button-send";

export default {
  name: 'Feedback',
  components:{
    buttonSend
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  data() {
      return {
          answer: null,
          state: false,
          feed: "",
          option: null
      }
  },
  methods: {
  }
}
</script>

<style scoped>
@import 'feedback.scss';
</style>
